<template>
  <div class="container">
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="disabledPull || activityInfo.activityStatus !== 1"
      @refresh="onRefresh"
    >
      <div v-if="!isLive" class="pageNative flex_center">
        <div
          v-if="activityInfo.activityStatus === 0"
          class="nativeStatus flex_center"
        >
          活动将于 {{ activityInfo.startTime }} 开始
        </div>
        <div
          v-else
          class="nativeStatus flex_center"
        >
          活动已结束
        </div>
      </div>
      <div v-else class="page">
        <!-- 头图 -->
        <div
          class="header bg_contain"
          :style="{
            backgroundImage: `url(${activityInfo.banner})`,
          }"
        >
        </div>
        <div class="main">
          <div class="select_wrap ml_12 mr_12">
            <GameSelect4
              v-if="curActGameId"
              :gameList="gameList"
              :activeGameId="curActGameId"
              :disabled="disabledRoll"
              @more="triggerMoreGame"
              @changeActiveGame="onChangeActiveGame"
            />
          </div>
          <div class="roll_wrap bg_contain" :style="{
            backgroundImage: `url(${CDN_URL}/roll_bg.png)`,
          }">
            <div class="roll_main">
              <div class="sifter_wrap">
                <div
                  class="sifter_bg bg_contain"
                  :style="{ backgroundImage: `url(${CDN_URL}/sifter_wrap.png)` }"
                  @click="onRoll"
                >
                  <Sifter ref="sifterRef" :disabled="disabledRoll" @roll="onAfterRoll" />
                </div>
                <div class="sifter_text fs_12 text_center">
                  剩余<span style="color: #ff7734">{{ remainDrawNum }}</span>次
                </div>
              </div>
              <!-- 当前位置 -->
              <div class="user bg_contain" :class="{ p_start: curStepIdx === 0 }" :style="theStyle"></div>
              <div
                v-for="(s, i) in roads"
                :key="i"
                class="step flex_center"
                :style="{
                  ...s,
                  backgroundImage: `url(${CDN_URL}/${getStepIcon(i)}.png)`
                }"
                @click="handleClick(i)"
              >
                <div
                  class="step_text pre_line text_center"
                  :class="{ step_start_text: i === 0 }"
                >{{ getStepInnerText(i) }}</div>
                <!-- <div class="step_num">{{ getRewardItem(i).stepNum }}</div> -->
                 <template v-if="getRewardItem(i).rewardType === 1 && i > curStepIdx">
                   <div class="step_gift_main">
                     <div
                       class="step_gift_icon bg_contain"
                       :style="{ backgroundImage: `url(${getRewardItem(i).rewardIcon})` }"
                     />
                   </div>
                   <div
                     class="step_gift bg_contain io_none"
                     :style="{ backgroundImage: `url(${CDN_URL}/gift_wrap.png)` }"
                   ></div>
                   <div class="step_gift_text">{{ getRewardItem(i).rewardName }}</div>
                 </template>
              </div>
            </div>
            <div class="roll_record fs_12" @click="onClickRecord">奖励记录</div>
          </div>
          <!-- 任务 -->
          <div class="task">
            <div
              class="task_main bg_contain"
              :style="{ backgroundImage: `url(${CDN_URL}/task_wrap.png)` }"
            >
              <div class="task_item  flex_center" v-for="tk in tasks" :key="tk.taskId">
                <div class="task_name flex_1 w_0 fs_14">{{ genTaskText(tk, 1) }}</div>
                <div class="task_info mr_28 flex_center fs_13">
                  <div
                    class="task_icon bg_contain mr_4"
                    :style="{ backgroundImage: `url(${CDN_URL}/sifter_icon.png)` }"
                  />
                  <div class="task_text w_26 text_nowrap">+{{ tk.stepNum }}</div>
                </div>
                <div
                  class="task_oper flex_center d_flex_col"
                  :class="{ filter_grayscale: [2, 3].includes(tk.drawStatus) }"
                  @click="onReceived(tk)"
                >
                  <div
                    class="task_btn fs_13 mb_2 bg_contain"
                    :style="{ backgroundImage: `url(${CDN_URL}/btn.png)` }"
                  >{{ genTaskText(tk, 3) }}</div>
                  <div class="task_freq fs_8" style="color: #FFEA3C">{{ genTaskText(tk, 2) }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 提示 -->
          <div class="tip pb_20 pt_4">
            <p>温馨提示：</p>
            <p class="mt_6">该活动奖励与盒子内其余活动奖励不共享</p>
          </div>
        </div>
        <ActivityPopup
          :visible.sync="visible"
          v-bind="feedback"
          :headerStyle="{background: '#8A18E7'}"
          :innerTitleStyle="{color: '#8A18E7'}"
          confirmButtonColor="#8A18E7"
          cancelButtonColor="#00BFD3"
          @confirm="feedback.onSure"
          @cancel="feedback.onCancel"
        >
          <template v-if="feedbackType === FEEDTYPE_MAP.SUCCESS">
            <p v-if="getPoints" class="bold text_center fs_18 mb_24">{{ getPoints }}积分</p>
            <p
              class="text_center fs_18 mb_12"
              style="line-height: 22px;"
              v-for="g in getGifts"
              :key="g.rewardId"
            >
              <span class="bold" v-if="g.cdk">{{ g.rewardName }}</span>
              <template v-else>
                <span class="bold">【{{ g.rewardName }}】-</span>
                兑换码生成错误，请联系客服领取备用码
              </template>
            </p>
          </template>
          <template v-if="feedbackType === FEEDTYPE_MAP.CONDITION_NOT_SATISFY">
            <p class="text_center fs_18 mb_24 color_black bold">活动期间内单笔付费达{{ curTask.taskCondit }}元可领</p>
            <p class="text_center fs_15" style="color: #858585; line-height: 18px;">任务说明：单笔付费金额≥50可获得奖励</p>
            <p class="text_center fs_15" style="color: #858585; line-height: 18px;">小明今日充值一笔198元，因198元金额大于50元获得一次投掷机会</p>
          </template>
          <template v-if="feedbackType === FEEDTYPE_MAP.MORE_GAME">
            <div class="more_games">
              <div 
                v-for="item in gameList"
                :key="item.gameId"
                class="more_game text_center relative"
                @click="onSelectGame(item)"
              >
                <div
                  class="more_game_icon bg_contain"
                  :style="{
                    backgroundImage: `url(${item.logo})`
                  }"
                ></div>
                <div class="more_game_name scale09_center fs_15">{{ item.gameName }}</div>
              </div>
            </div>
          </template>
          <template v-if="feedbackType === FEEDTYPE_MAP.SHOW_GIFT">
            <div class="gift_show flex_center d_flex_col">
              <div class="gift_icon w_60 h_60 bg_contain mt_8 mb_16" :style="{ backgroundImage: `url(${curSelectStep.rewardIcon})` }" />
              <div class="gift_name fs_18 mb_24 bold">{{ curSelectStep.rewardName }}</div>
              <div class="gift_desc fs_16" style="line-height: 20px;">礼包内容：{{ curSelectStep.rewardContent }}</div>
            </div>
          </template>
        </ActivityPopup>
      </div>
      <Record
        ref="recordRef"
        :activityId="actId"
        :activityGameId="curGameInfo.activityGameId"
        @close="setDisabledPull"
        @goPoint="onGoPoint"
        @goGift="onGoGift"
      />
    </PullRefresh>
  </div>
</template>

<script>
import {
  setPageTitle, setRightTxt, clickRightTxt, toLogin,
} from "@/bridge/AppJsBridge";
import { roads, ActivityInfo, FEEDTYPE_MAP } from './config'
import { PullRefresh } from "vant";
import Sifter from './Sifter.vue';
import GameSelect4 from './gameSelect4.vue';
import {
  getZillianMainInfo, getZillianTasks, completeZillianTask, getZillianRewards,
  rollDiceApi,
} from '@/apis/wxActivity'
import AvoidFirstActivate from '@/mixins/avoidFirstActivate'
import EventTrack from '@/mixins/eventTrack'
import ActivityPopup from "@/subtree/h5/comps/Popup";
import LinkTo from '@/mixins/linkTo'
import { getCookie } from "@/libs/utils";
import Record from './record'
import { CDN_URL_1 } from "@/config";

const timePerStep = 0.6
const {
  SUCCESS, INSUFFICIENT_GIFT, SHOW_GIFT, MORE_GAME,
  REACH_LIMIT, NO_CHANCE, NO_ROLE, CONDITION_NOT_SATISFY,
} = FEEDTYPE_MAP
const noop = () => {}

export default {
  components: {
    Sifter,
    Record,
    GameSelect4,
    ActivityPopup,
    PullRefresh,
  },
  mixins: [EventTrack, LinkTo, AvoidFirstActivate],
  activated () {
    this.triggerVisible(false)
    this.hasFetched = false
    if (this.activityInfo.name) {
      setRightTxt('活动规则');
    }
  },
  data () {
    return {
      CDN_URL: CDN_URL_1 + '/box_zillionaire',
      isWx: true,
      isLoading: false,
      disabledPull: false,
      roads,
      curStepIdx: 0,
      curSelectStep: {}, // 当前点击的点位
      diceStepVos: [], // 服务端返回的获得的奖励列表
      disabledRoll: false,
      rollApiLoading: false, // 进一步防止重复点击
      randomNum: 1,
      isLooping: false,
      hasFetched: false,
      activityInfo: new ActivityInfo(),
      tasks: [],
      curActGameId: '', // 活动会场id
      receiveLoading: false,
      curTask: {},
      remainDrawNum: 0, // 剩余抽奖次数
      rewardVos: [],
      visible: false,
      FEEDTYPE_MAP,
      feedbackType: NO_ROLE,
    }
  },
  computed: {
    actId () {
      return this.$route.query.id
    },
    curGameInfo () {
      if (!this.curActGameId) return {}
      return this.gameList.find(i => i.gameId === this.curActGameId) || {}
    },
    gameList () {
      return this.activityInfo.gameVoList || []
    },
    isLive () {
      if (!this.hasFetched) return true
      // 没登录不给结束
      if ((!this.activityInfo.activityId && this.cookie) && this.hasFetched) return false
      return this.activityInfo.activityStatus === 1
    },
    theStyle () {
      return roads.find((item, idx) => idx === this.curStepIdx) || {};
    },
    isFinished () {
      return this.curStepIdx === this.roads.length - 1;
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      const isRealSuccess = this.getGifts.every(i => i.cdk)
      return {
        [SUCCESS]: {
          title: '恭喜您获得',
          confirmButtonText: isRealSuccess ? '继续前进' : '联系客服',
          showCancelButton: true,
          cancelButtonText: '点我查看',
          onSure: () => {
            this.eventTrack({
              event: "rich_man_reward_result_pop_button",
              event_field: this.getTrackInfo({
                reward_info: JSON.stringify(this.diceStepVos.map(i => ({
                  reward_id: i.rewardId,
                  reward_name: i.rewardName,
                  reward_type: i.rewardType,
                }))),
                type: isRealSuccess ? 1 : 3,
              }),
              ...this.trackGameInfo,
            })
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.eventTrack({
              event: "rich_man_reward_result_pop_button",
              event_field: this.getTrackInfo({
                reward_info: JSON.stringify(this.diceStepVos.map(i => ({
                  reward_id: i.rewardId,
                  reward_name: i.rewardName,
                  reward_type: i.rewardType,
                }))),
                type: 2,
              }),
              ...this.trackGameInfo,
            })
            // 这里的 SHOW_GIFT 是故意未知
            this.triggerVisible(false, SHOW_GIFT)
            this.onShowRewardRecord()
          }
        },
        [NO_ROLE]: {
          title: '任务提示',
          message: [
            '在活动时间内下载游戏',
            '并用此账号创角即可领取奖励',
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            const { taskId, taskType, stepNum } = this.curTask
            this.eventTrack({
              event: "rich_man_task_to_complete_button",
              event_field: this.getTrackInfo({
                pop_type: 1,
                task_id: taskId,
                task_type: taskType,
                step_num: stepNum,
              }),
              ...this.trackGameInfo,
            })
            this.triggerVisible(false)
            this.goDownload()
          },
          onCancel: noop,
        },
        [REACH_LIMIT]: {
          title: '提示',
          message: [
            '您已获得该游戏会场全部奖励啦!',
            '去其他会场看看吧~'
          ],
          confirmButtonText: '参与其他会场',
          onSure: () => {
            this.eventTrack({
              event: "rich_man_join_other_button",
              event_field: this.getTrackInfo({
                curt_step: this.curStepIdx, // 这里肯定是 17
              }),
              ...this.trackGameInfo,
            })
            this.onGoNextGame()
            this.triggerVisible(false)
          },
          onCancel: noop,
        },
        [MORE_GAME]: {
          title: '更多游戏',
          innerTitle: '请选择',
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: noop,
        },
        [CONDITION_NOT_SATISFY]: {
          title: '任务提示',
          confirmButtonText: '去完成',
          onSure: () => {
            const { taskId, taskType, stepNum } = this.curTask
            this.eventTrack({
              event: "rich_man_task_to_complete_button",
              event_field: this.getTrackInfo({
                pop_type: 1,
                task_id: taskId,
                task_type: taskType,
                step_num: stepNum,
              }),
              ...this.trackGameInfo,
            })
            this.triggerVisible(false)
            this.goDownload()
          },
          onCancel: noop,
        },
        [NO_CHANCE]: {
          title: '提示',
          confirmButtonText: '去完成',
          message: [
            '掷骰子机会剩余 0 次',
            '快去完成任务获得更多机会吧！'
          ],
          onSure: () => {
            this.eventTrack({
              event: "rich_man_task_to_complete_button",
              event_field: this.getTrackInfo({
                pop_type: 2,
              }),
              ...this.trackGameInfo,
            })
            this.triggerVisible(false)
            this.goDownload()
          },
          onCancel: noop,
        },
        [SHOW_GIFT]: {
          title: '奖励详情',
          confirmButtonText: '继续前进',
          onSure: () => {
            const { rewardName, rewardId } = this.curSelectStep
            this.eventTrack({
              event: "rich_man_continue_button",
              event_field: this.getTrackInfo({
                reward_id: rewardId,
                reward_name: rewardName,
              }),
              ...this.trackGameInfo,
            })
            this.triggerVisible(false)
          },
          onCancel: noop,
        },
      }
    },
    // 处理骰子结果
    getPoints () {
      return this.diceStepVos
        .filter(v => v.rewardType === 2)
        .reduce((pre, cur) => pre + cur.rewardId, 0)
    },
    getGifts () {
      return this.diceStepVos
        .filter(v => v.rewardType === 1)
    },
    fullStepCount () {
      return this.rewardVos.length
    },
    trackGameInfo () {
      return {
        appName: this.curGameInfo.gameName,
        appkey: this.curGameInfo.gameId
      }
    },
  },
  methods: {
    getActivityInfo () {
      this.init()
    },
    init (first = true) {
      return this.getActInfo(first)
        .then(() => {
          this.eventTrack({
            event: "rich_man_home_page",
            event_field: this.getTrackInfo({}, false),
          })
          setPageTitle(this.activityInfo.name)
          this.setHeaderContent()
        })
        .finally(() => {
          this.hasFetched = true
        })
    },
    onRefresh () {
      this.init(false).finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 50)
      })
    },
    // 活动信息
    getActInfo (first) {
      return getZillianMainInfo({ activityId: this.actId })
        .then(res => {
          this.activityInfo = res.data || new ActivityInfo()
          setTimeout(() => {
            if (this.isLive) {
              if (this.gameList.length) {
                if (first) {
                  this.curActGameId = this.gameList[0].gameId
                }
                this.getTasks()
                this.getRewards(true)
              }
            }
          })
        }).catch(err => {
          // 活动下架
          if ([90130].includes(err.code)) {
            this.activityInfo.activityStatus = 2
          }
          if (err.response && err.response.data.code === 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity")
          }
        })
    },
    getRewards (f = false) {
      getZillianRewards({
        activityId: this.actId,
        activityGameId: this.curGameInfo.activityGameId,
      }).then(res => {
        const { curStepNum, remainDrawNum, rewardVos } = res.data || {}
        this.rewardVos = rewardVos || []
        this.curStepIdx = curStepNum
        this.remainDrawNum = remainDrawNum
        this.$nextTick(() => {
          if (f && this.isFinished) {
            if (this.setGamePlaceDone()) {
              this.triggerVisible(true, REACH_LIMIT)
            }
          }
        })
      })
    },
    // 任务信息
    getTasks () {
      getZillianTasks({
        activityId: this.actId,
        activityGameId: this.curGameInfo.activityGameId,
      }).then(res => {
        this.tasks = res.data || []
      })
    },
    triggerMoreGame () {
      this.eventTrack({
        event: "rich_man_more_game_button",
        event_field: this.getTrackInfo({}),
      })
      this.triggerVisible(true, MORE_GAME)
    },
    onChangeActiveGame (game) {
      this.curActGameId = game.gameId
      this.eventTrack({
        event: "rich_man_game_place_icon",
        event_field: this.getTrackInfo({}),
        ...this.trackGameInfo,
      })
      this.$nextTick(() => {
        this.getTasks()
        this.getRewards(true)
      })
    },
    triggerVisible (visible, type) {
      if (visible && this.visible) return
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
      this.extraTrack(visible, type)
      // 额外的逻辑
      if (!visible && this.feedbackType === SUCCESS) {
        if (this.isFinished) {
          setTimeout(() => {
            this.triggerVisible(true, REACH_LIMIT)
          }, 500)
        }
      }
    },
    extraTrack (v, type) {
      if (v) {
        if (type === REACH_LIMIT) {
          this.eventTrack({
            event: "rich_man_tip_pop",
            event_field: this.getTrackInfo({
              curt_step: this.curStepIdx,
            }),
            ...this.trackGameInfo,
          })
        }
      }
    },
    handleClick (i) {
      const it = this.getRewardItem(i)
      const { rewardType, rewardId, rewardName } = it
      this.curSelectStep = it
      if (rewardType === 1) {
        this.triggerVisible(true, SHOW_GIFT)
        this.eventTrack({
          event: "rich_man_step_click",
          event_field: this.getTrackInfo({
            reward_type: rewardType,
            reward_id: rewardId,
            reward_name: rewardName,
          }),
          ...this.trackGameInfo,
        })
      }
    },
    onRoll () {
      // 本地环境可能一直是 Null
      if (!getCookie("token")) return
      const count = this.remainDrawNum
      if (count === 0) {
        this.eventTrack({
          event: "rich_man_task_not_complete_pop",
          event_field: this.getTrackInfo({
            pop_type: 2,
          }),
          ...this.trackGameInfo,
        })
        this.triggerVisible(true, NO_CHANCE)
        return 
      }
      if (this.curStepIdx === this.fullStepCount) {
        this.triggerVisible(true, REACH_LIMIT)
        return
      }
      if (this.disabledRoll || this.rollApiLoading) return
      rollDiceApi({
        activityId: this.actId,
        activityGameId: this.curGameInfo.activityGameId,
      }).then(res => {
        const { diceStepVos, remainDrawNum, stepNum } = res.data || {}
        this.remainDrawNum = remainDrawNum
        this.diceStepVos = diceStepVos
        this.eventTrack({
          event: "rich_man_dice_button",
          event_field: this.getTrackInfo({
            step_num: stepNum,
            remain_num: remainDrawNum
          }),
          ...this.trackGameInfo,
        })
        // 掷骰子
        if (this.$refs.sifterRef) {
          this.$refs.sifterRef.rollDice(stepNum)
          this.disabledRoll = true
        }
      }).catch(err => {
        const { code } = err
        // 边缘case
        if ([95514, 95507].includes(code)) {
          this.getRewards()
        }
      }).finally(() => {
        setTimeout(() => { this.rollApiLoading = false }, 500)
      })
    },
    onAfterRoll (steps) {
      this.randomNum = steps
      this.goInter = setInterval(() => {
        if (!steps-- || this.curStepIdx === this.fullStepCount) {
          this.eventTrack({
            event: "rich_man_user_step",
            event_field: this.getTrackInfo({
              curt_step: this.curStepIdx,
            }),
            ...this.trackGameInfo,
          })
          this.eventTrack({
            event: "rich_man_reward_result_pop",
            event_field: this.getTrackInfo({
              reward_info: JSON.stringify(this.diceStepVos.map(i => ({
                reward_id: i.rewardId,
                reward_name: i.rewardName,
                reward_type: i.rewardType,
              }))),
              result: this.getGifts.every(i => i.cdk),
            }),
            ...this.trackGameInfo,
          })
          this.triggerVisible(true, SUCCESS)
          setTimeout(() => { this.disabledRoll = false }, 500)
          this.getRewards()
          return this.clearGoInterval()
        }
        if (this.curStepIdx < this.fullStepCount) {
          this.curStepIdx = this.curStepIdx + 1;
        }
      }, timePerStep * 1000)
    },
    // 领取任务奖励
    onReceived (tk) {
      const { drawStatus, taskId, taskType, stepNum } = tk
      if ([2, 3].includes(drawStatus)) return
      this.curTask = tk
      if (this.receiveLoading) return
      this.receiveLoading = true
      completeZillianTask({
        taskId: taskId,
      }).then(res => {
        const { rewardStepNum } = res.data
        this.$toast(`掷骰子次数+${rewardStepNum}`)
        this.getTasks()
        this.getRewards()
        this.eventTrack({
          event: "rich_man_task_draw_button",
          event_field: this.getTrackInfo({
            task_type: taskType,
            task_id: taskId,
            step_num: rewardStepNum,
            button_type: 2
          }),
          ...this.trackGameInfo,
        })
      }).catch(err => {
        const { code, msg } = err
        if ([95512, 95509].includes(code)) {
          this.eventTrack({
            event: "rich_man_task_draw_button",
            event_field: this.getTrackInfo({
              task_type: taskType,
              task_id: taskId,
              step_num: stepNum,
              button_type: 1
            }),
            ...this.trackGameInfo,
          })
          this.eventTrack({
            event: "rich_man_task_not_complete_pop",
            event_field: this.getTrackInfo({
              task_type: taskType,
              task_id: taskId,
              step_num: stepNum,
              pop_type: 1,
            }),
            ...this.trackGameInfo,
          })
        }
        if (code === 95509) {
          // 未创角
          this.triggerVisible(true, NO_ROLE)
          return
        }
        if (code === 95512) {
          // 活动期间内单笔付费达X元可领
          this.triggerVisible(true, CONDITION_NOT_SATISFY)
          return
        }
        this.$toast(msg)
      }).finally(() => {
        this.receiveLoading = false
      })
    },
    clearGoInterval () {
      this.goInter && clearInterval(this.goInter)
      this.goInter = null;
    },
    getRewardItem (i) {
      return (Array.isArray(this.rewardVos) && this.rewardVos.find(it => it.stepNum === i)) || {}
    },
    getStepIcon (i) {
      const it = this.getRewardItem(i)
      if (i === 0) return 'start'
      if (it.rewardType === 1) {
        if (this.curStepIdx === it.stepNum) return 'gift_at'
        if (this.isPassedStep(i)) return 'step_gift_done'
        return 'step_gift'
        // return i > this.curStepIdx ? 'step_gift' : 'step_gift_done'
      }
      if (!it.rewardType || it.rewardType === 2) {
        if (this.curStepIdx === it.stepNum) return 'point_at'
        if (this.isPassedStep(i)) return 'step_point_done'
        return 'step_point'
        // return i > this.curStepIdx ? 'step_point' : 'step_point_done'
      }
    },
    getStepInnerText (i) {
      const it = this.getRewardItem(i)
      if (i === 0) return `起点`
      if (it.rewardType === 2) {
        if (this.isPassedStep(i)) return `积分\n已领取`
        return it.rewardName
      }
      if (it.rewardType === 1 && this.isPassedStep(i)) return `礼包\n已领取`
    },
    // 当前 step === stepIdx
    isCurrentStep (i) {
      return this.curStepIdx === i 
    },
    isPassedStep (i) {
      return this.curStepIdx > i
    },
    genTaskText (tk = {}, type) {
      const { taskType, taskCondit, refresh, drawStatus } = tk
      // 条件文案
      if (type === 1) {
        return taskType === 1 ? '游戏内首次创角' : `单笔付费≥${taskCondit}元`
      }
      // 频率文案
      if (type === 2) {
        return refresh === 1 ? '仅一次' : '多次领取'
      }
      // 按钮文案
      if (type === 3) {
        const textArr = ['去完成', '领取', '已领取', '历史创角']
        return textArr[drawStatus]
      }
    },
    goDownload () {
      // 40 -> 拉新拉收
      this.handleGoDownload(this.curGameInfo.gameId, 40)
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.eventTrack({
          event: "rich_man_rule_button",
          event_field: this.getTrackInfo(),
        })
        this.handleGoRulePage(29)
      });
    },
    onSelectGame (gm) {
      this.triggerVisible(false)
      this.onChangeActiveGame(gm)
    },
    // 去到下一个游戏会场
    onGoNextGame () {
      const gl = this.gameList
      if (gl.length <= 1) return
      const i = gl.findIndex(gm => gm.gameId === this.curActGameId)
      const next = (i === gl.length - 1) ? 0 : (i + 1)
      this.onChangeActiveGame(gl[next], false)
    },
    onClickRecord () {
      this.eventTrack({
        event: "rich_man_reward_record_button",
        event_field: this.getTrackInfo(),
        ...this.trackGameInfo,
      })
      this.onShowRewardRecord()
    },
    onShowRewardRecord () {
      this.$refs.recordRef.triggerVisible(true)
      this.setDisabledPull(true)
      this.eventTrack({
        event: "rich_man_reward_record_page",
        event_field: this.getTrackInfo(),
        ...this.trackGameInfo,
      })
    },
    setDisabledPull (f = false) {
      this.disabledPull = f
    },
    onGoGift (it) {
      const { cdk, rewardId, rewardName } = it || {}
      setTimeout(() => {
        if (cdk) {
          this.handleGoGift()
        } else {
          this.onRelationServer()
        }
      }, 100)
      this.eventTrack({
        event: "rich_man_view_reward_button",
        event_field: this.getTrackInfo({
          reward_id: rewardId,
          reward_name: rewardName,
          type: cdk ? 3 : 4,
        }),
        ...this.trackGameInfo,
      })
    },
    onGoPoint (it) {
      const { rewardId, rewardName } = it || {}
      this.eventTrack({
        event: "rich_man_view_reward_button",
        event_field: this.getTrackInfo({
          reward_id: rewardId,
          reward_name: rewardName,
          type: 2,
        }),
        ...this.trackGameInfo,
      })
      setTimeout(() => {
        this.handleGoPointsMall()
      }, 100)
    },
    track (params) {
      const { event } = params
    },
    getTrackInfo (params = {}) {
      return JSON.stringify({
        activity_id: this.actId,
        activity_name: this.activityInfo.name,
        ...params,
      })
    },
    // 当前游戏会场走完了
    setGamePlaceDone () {
      const { gameId } = this.curGameInfo
      const store = JSON.parse(localStorage.getItem('zillionaire_done_place') || '{}')
      const currentPlace = store[this.actId] || []
      if (currentPlace.includes(gameId)) return false
      localStorage.setItem(
        'zillionaire_done_place',
        JSON.stringify({
         ...store,
          [this.actId]: [...currentPlace, gameId],
        })
      )
      return true
    },
  }
}
</script>

<style lang="scss">
.popup_title {
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.page, .pageNative {
  position: relative;
  min-height: 100vh;
  background-color: #202233;
  transition: 0.2s all ease;
  color: #fff;
  ::v-deep .popup_content {
    color: #333;
  }
}
.page {
  color: #fff;
  padding-top: 214px;
}
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 225px;
}
.roll_wrap {
  width: 100vw;
  height: 355px;
  position: relative;
  background-position: 50% 0;
  padding-top: 48px;
  .roll_main {
    // 22 * (60 / 4) = 330
    width: 330px;
    // 13 * (50 / 2) - 3 * 50 * 0.16 = 301
    height: 301px;
    position: relative;
    margin: 0 auto 0;
  }
  .sifter_wrap {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 42%;
    left: 50%;
    z-index: 30;
    .sifter_bg {
      width: 118px;
      height: 118px;
      padding-top: 36px;
    }
  }
  .user {
    position: absolute;
    width: 60px !important;
    height: 67px !important;
    z-index: 30 !important;
    border-radius: 50%;
    transition: all 0.6s ease;
    transform: translate(-50%, -85%);
    background-image: url('https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_zillionaire/me.png');
  }
  .p_start {
    transform: translate(-42%, -80%);
  }
  .step {
    position: absolute;
    top: 20px;
    left: 20px;
    // background-color: #bbb;
    // transform: rotateX(10deg);
    background-image: url('https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_zillionaire/step_point.png');
    background-size: contain;
    background-repeat: no-repeat;
    transform: translate(-50%, -50%) scale(1);
    padding-bottom: 12px;
    transition: 0.3s all ease;
  }
  .step_text {
    // font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    color: #fff7ef;
    text-shadow: 1px 1px#1b1b21; 
    font-style: italic;
  }
  .step_start_text {
    font-size: 12px;
    color: #ffe5a3;
    padding-top: 5px;
    padding-left: 7px;
  }
  .step_gift {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: 10px;
    left: 50%;
    z-index: 20;
    transform: translate(-50%, 0);
  }
  .step_gift_main {
    position: absolute;
    bottom: 28px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 20;
    .step_gift_icon {
      width: 32px;
      height: 32px;
      margin-bottom: 4px;
    }
  }
  .step_gift_text {
    position: absolute;
    bottom: 19px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 9px;
    font-weight: bold;
    font-style: italic;
    white-space: nowrap;
    z-index: 20;
  }
  .roll_record {
    position: absolute;
    top: 24px;
    right: 12px;
  }
}

.task {
  .task_main {
    width: 100%;
    height: 265px;
    padding: 98px 26px 0 30px;
    .task_item {
      padding: 8px 8px 8px 16px;
      background: #1b1f24;
      border-radius: 8px;
      .task_btn {
        text-align: center;
        width: 92px;
        height: 36px;
        padding-top: 14px;
      }
      .task_icon {
        width: 22px;
        height: 22px;
      }
    }
    .task_item + .task_item {
     margin-top: 6px; 
    }
  }
}

// 更多游戏
.more_games {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 14px 0px;
  margin: 0 auto;
  max-height: 260px;
  overflow: auto;
  .more_game {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 84px;
    margin-bottom: 8px;
    .more_game_icon {
      width: 58px;
      height: 58px;
      margin-bottom: 5px;
      border-radius: 6px;
    }
  }
}

.tip {
  p {
    text-align: center;
    font-size: 15px;
    color: #ffed87;
  }
}

.io_none {
  pointer-events: none;
  user-select: none;
}
</style>
